import gql from 'graphql-tag';

const removeFavoriteMutation = gql`
  mutation removeFavorite($input: RemoveFavoriteInput!) {
    removeFavorite(input: $input) {
      gotRemoved
      pagesGotShifted
      id
    }
  }
`;

export default removeFavoriteMutation;
